import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import '../styles/general.css';

/**
 * Shown when the session is valid but lacks the required access.
 *
 * Rendered in place rather than redirected to, so the URL the user tried stays
 * in the address bar and they can see what was denied. The previous behaviour
 * sent them to /login, which asks someone already signed in to sign in again
 * and reads as though their session had broken.
 */
const ForbiddenPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="page-container text-center" data-testid="forbidden-page">
      <h1>{t('common.forbiddenTitle')}</h1>
      <p className="text-muted mb-20">{t('common.forbiddenMessage')}</p>
      <button onClick={() => navigate('/dashboard')} className="btn btn-primary">
        {t('common.backToDashboard')}
      </button>
    </div>
  );
};

export default ForbiddenPage;
